import React from 'react';
import { Field, reduxForm } from 'redux-form'
import {database} from '../app-database';

class ContratoForm extends React.Component{

	state = {
		contrato : ""
	}

	componentWillMount = () =>{
		var $this = this;
		database.ref("/documentacion/confidencialidad").once('value').then(function(data){
			$this.setState({ "contrato" : data.val() });  
		});
	}
	
	cancelar = () => {
		this.props.change('acepto', false);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: false }))();
	}
	
	aceptar = () => {
		this.props.change('acepto', true);
		this.props.handleSubmit(values => this.props.onSubmit({ ...values, acepto: true }))();
	}
	
	render() {
		const { handleSubmit, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className='text-content'>
					<div className="datos-wrap row">
						<div className="col-xs-12" style={{ "height": "400px", "overflowY": "scroll" }}>
							<h3>Términos y Condiciones del Uso de Medios Electrónicos</h3><br/>
							<div dangerouslySetInnerHTML={{__html: this.state.contrato}} className="txt-gray"></div>
						</div>
					</div>
					<div className="text-center aceptar-cancelar-btn mt-75 xs-no-mt">
						<a onClick={this.cancelar}>Cancelar</a>
						<a onClick={this.aceptar} className="orange-text">Aceptar</a>
					</div>
				</div>
				<Field name="acepto" component="input" type="hidden" />
			</form>
		)
	}
}

export default ContratoForm = reduxForm({form: 'contrato'})(ContratoForm);


// WEBPACK FOOTER //
// ./src/contrato/contrato.frm.js